// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VenturesRouteImport } from './routes/ventures'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as ShamaniIndustriesRouteImport } from './routes/shamani-industries'
import { Route as SearchRouteImport } from './routes/search'
import { Route as RajShamaniWifeRouteImport } from './routes/raj-shamani-wife'
import { Route as RajShamaniSuccessStoryRouteImport } from './routes/raj-shamani-success-story'
import { Route as RajShamaniSpeakerRouteImport } from './routes/raj-shamani-speaker'
import { Route as RajShamaniQuotesRouteImport } from './routes/raj-shamani-quotes'
import { Route as RajShamaniPodcastRouteImport } from './routes/raj-shamani-podcast'
import { Route as RajShamaniNetWorthRouteImport } from './routes/raj-shamani-net-worth'
import { Route as RajShamaniLifestyleRouteImport } from './routes/raj-shamani-lifestyle'
import { Route as RajShamaniInstagramRouteImport } from './routes/raj-shamani-instagram'
import { Route as RajShamaniIncomeRouteImport } from './routes/raj-shamani-income'
import { Route as RajShamaniFamilyRouteImport } from './routes/raj-shamani-family'
import { Route as RajShamaniEducationRouteImport } from './routes/raj-shamani-education'
import { Route as RajShamaniContactDetailsRouteImport } from './routes/raj-shamani-contact-details'
import { Route as RajShamaniBusinessRouteImport } from './routes/raj-shamani-business'
import { Route as RajShamaniBooksRouteImport } from './routes/raj-shamani-books'
import { Route as RajShamaniBiographyRouteImport } from './routes/raj-shamani-biography'
import { Route as RajShamaniAgeRouteImport } from './routes/raj-shamani-age'
import { Route as HouseOfXRouteImport } from './routes/house-of-x'
import { Route as GuestRouteImport } from './routes/guest'
import { Route as FiguringOutPodcastGuestsRouteImport } from './routes/figuring-out-podcast-guests'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FailureResumeRouteImport } from './routes/failure-resume'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BuildDontTalkRouteImport } from './routes/build-dont-talk'
import { Route as BookRouteImport } from './routes/book'
import { Route as AionRouteImport } from './routes/aion'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PodcastIndexRouteImport } from './routes/podcast.index'
import { Route as PodcastSlugRouteImport } from './routes/podcast.$slug'
import { Route as GuidesHowToUseAiInBusinessIndiaRouteImport } from './routes/guides.how-to-use-ai-in-business-india'
import { Route as GuidesHowToStartAPodcastIndiaRouteImport } from './routes/guides.how-to-start-a-podcast-india'
import { Route as GuidesHowToGrowOnInstagramIndiaRouteImport } from './routes/guides.how-to-grow-on-instagram-india'
import { Route as GuidesHowToBecomeAnAngelInvestorIndiaRouteImport } from './routes/guides.how-to-become-an-angel-investor-india'
import { Route as GuidesHowToBecomeAnAiEngineerIndiaRouteImport } from './routes/guides.how-to-become-an-ai-engineer-india'
import { Route as GuidesD2cBrandsIndiaRouteImport } from './routes/guides.d2c-brands-india'

const VenturesRoute = VenturesRouteImport.update({
            id: '/ventures',path: '/ventures',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const ShamaniIndustriesRoute = ShamaniIndustriesRouteImport.update({
            id: '/shamani-industries',path: '/shamani-industries',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const RajShamaniWifeRoute = RajShamaniWifeRouteImport.update({
            id: '/raj-shamani-wife',path: '/raj-shamani-wife',getParentRoute: () => rootRouteImport
          })
const RajShamaniSuccessStoryRoute = RajShamaniSuccessStoryRouteImport.update({
            id: '/raj-shamani-success-story',path: '/raj-shamani-success-story',getParentRoute: () => rootRouteImport
          })
const RajShamaniSpeakerRoute = RajShamaniSpeakerRouteImport.update({
            id: '/raj-shamani-speaker',path: '/raj-shamani-speaker',getParentRoute: () => rootRouteImport
          })
const RajShamaniQuotesRoute = RajShamaniQuotesRouteImport.update({
            id: '/raj-shamani-quotes',path: '/raj-shamani-quotes',getParentRoute: () => rootRouteImport
          })
const RajShamaniPodcastRoute = RajShamaniPodcastRouteImport.update({
            id: '/raj-shamani-podcast',path: '/raj-shamani-podcast',getParentRoute: () => rootRouteImport
          })
const RajShamaniNetWorthRoute = RajShamaniNetWorthRouteImport.update({
            id: '/raj-shamani-net-worth',path: '/raj-shamani-net-worth',getParentRoute: () => rootRouteImport
          })
const RajShamaniLifestyleRoute = RajShamaniLifestyleRouteImport.update({
            id: '/raj-shamani-lifestyle',path: '/raj-shamani-lifestyle',getParentRoute: () => rootRouteImport
          })
const RajShamaniInstagramRoute = RajShamaniInstagramRouteImport.update({
            id: '/raj-shamani-instagram',path: '/raj-shamani-instagram',getParentRoute: () => rootRouteImport
          })
const RajShamaniIncomeRoute = RajShamaniIncomeRouteImport.update({
            id: '/raj-shamani-income',path: '/raj-shamani-income',getParentRoute: () => rootRouteImport
          })
const RajShamaniFamilyRoute = RajShamaniFamilyRouteImport.update({
            id: '/raj-shamani-family',path: '/raj-shamani-family',getParentRoute: () => rootRouteImport
          })
const RajShamaniEducationRoute = RajShamaniEducationRouteImport.update({
            id: '/raj-shamani-education',path: '/raj-shamani-education',getParentRoute: () => rootRouteImport
          })
const RajShamaniContactDetailsRoute = RajShamaniContactDetailsRouteImport.update({
            id: '/raj-shamani-contact-details',path: '/raj-shamani-contact-details',getParentRoute: () => rootRouteImport
          })
const RajShamaniBusinessRoute = RajShamaniBusinessRouteImport.update({
            id: '/raj-shamani-business',path: '/raj-shamani-business',getParentRoute: () => rootRouteImport
          })
const RajShamaniBooksRoute = RajShamaniBooksRouteImport.update({
            id: '/raj-shamani-books',path: '/raj-shamani-books',getParentRoute: () => rootRouteImport
          })
const RajShamaniBiographyRoute = RajShamaniBiographyRouteImport.update({
            id: '/raj-shamani-biography',path: '/raj-shamani-biography',getParentRoute: () => rootRouteImport
          })
const RajShamaniAgeRoute = RajShamaniAgeRouteImport.update({
            id: '/raj-shamani-age',path: '/raj-shamani-age',getParentRoute: () => rootRouteImport
          })
const HouseOfXRoute = HouseOfXRouteImport.update({
            id: '/house-of-x',path: '/house-of-x',getParentRoute: () => rootRouteImport
          })
const GuestRoute = GuestRouteImport.update({
            id: '/guest',path: '/guest',getParentRoute: () => rootRouteImport
          })
const FiguringOutPodcastGuestsRoute = FiguringOutPodcastGuestsRouteImport.update({
            id: '/figuring-out-podcast-guests',path: '/figuring-out-podcast-guests',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FailureResumeRoute = FailureResumeRouteImport.update({
            id: '/failure-resume',path: '/failure-resume',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BuildDontTalkRoute = BuildDontTalkRouteImport.update({
            id: '/build-dont-talk',path: '/build-dont-talk',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const AionRoute = AionRouteImport.update({
            id: '/aion',path: '/aion',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PodcastIndexRoute = PodcastIndexRouteImport.update({
            id: '/podcast/',path: '/podcast/',getParentRoute: () => rootRouteImport
          })
const PodcastSlugRoute = PodcastSlugRouteImport.update({
            id: '/podcast/$slug',path: '/podcast/$slug',getParentRoute: () => rootRouteImport
          })
const GuidesHowToUseAiInBusinessIndiaRoute = GuidesHowToUseAiInBusinessIndiaRouteImport.update({
            id: '/guides/how-to-use-ai-in-business-india',path: '/guides/how-to-use-ai-in-business-india',getParentRoute: () => rootRouteImport
          })
const GuidesHowToStartAPodcastIndiaRoute = GuidesHowToStartAPodcastIndiaRouteImport.update({
            id: '/guides/how-to-start-a-podcast-india',path: '/guides/how-to-start-a-podcast-india',getParentRoute: () => rootRouteImport
          })
const GuidesHowToGrowOnInstagramIndiaRoute = GuidesHowToGrowOnInstagramIndiaRouteImport.update({
            id: '/guides/how-to-grow-on-instagram-india',path: '/guides/how-to-grow-on-instagram-india',getParentRoute: () => rootRouteImport
          })
const GuidesHowToBecomeAnAngelInvestorIndiaRoute = GuidesHowToBecomeAnAngelInvestorIndiaRouteImport.update({
            id: '/guides/how-to-become-an-angel-investor-india',path: '/guides/how-to-become-an-angel-investor-india',getParentRoute: () => rootRouteImport
          })
const GuidesHowToBecomeAnAiEngineerIndiaRoute = GuidesHowToBecomeAnAiEngineerIndiaRouteImport.update({
            id: '/guides/how-to-become-an-ai-engineer-india',path: '/guides/how-to-become-an-ai-engineer-india',getParentRoute: () => rootRouteImport
          })
const GuidesD2cBrandsIndiaRoute = GuidesD2cBrandsIndiaRouteImport.update({
            id: '/guides/d2c-brands-india',path: '/guides/d2c-brands-india',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AionRoute: AionRoute,BookRoute: BookRoute,BuildDontTalkRoute: BuildDontTalkRoute,ContactRoute: ContactRoute,FailureResumeRoute: FailureResumeRoute,FaqRoute: FaqRoute,FiguringOutPodcastGuestsRoute: FiguringOutPodcastGuestsRoute,GuestRoute: GuestRoute,HouseOfXRoute: HouseOfXRoute,RajShamaniAgeRoute: RajShamaniAgeRoute,RajShamaniBiographyRoute: RajShamaniBiographyRoute,RajShamaniBooksRoute: RajShamaniBooksRoute,RajShamaniBusinessRoute: RajShamaniBusinessRoute,RajShamaniContactDetailsRoute: RajShamaniContactDetailsRoute,RajShamaniEducationRoute: RajShamaniEducationRoute,RajShamaniFamilyRoute: RajShamaniFamilyRoute,RajShamaniIncomeRoute: RajShamaniIncomeRoute,RajShamaniInstagramRoute: RajShamaniInstagramRoute,RajShamaniLifestyleRoute: RajShamaniLifestyleRoute,RajShamaniNetWorthRoute: RajShamaniNetWorthRoute,RajShamaniPodcastRoute: RajShamaniPodcastRoute,RajShamaniQuotesRoute: RajShamaniQuotesRoute,RajShamaniSpeakerRoute: RajShamaniSpeakerRoute,RajShamaniSuccessStoryRoute: RajShamaniSuccessStoryRoute,RajShamaniWifeRoute: RajShamaniWifeRoute,SearchRoute: SearchRoute,ShamaniIndustriesRoute: ShamaniIndustriesRoute,UnsubscribeRoute: UnsubscribeRoute,VenturesRoute: VenturesRoute,GuidesD2cBrandsIndiaRoute: GuidesD2cBrandsIndiaRoute,GuidesHowToBecomeAnAiEngineerIndiaRoute: GuidesHowToBecomeAnAiEngineerIndiaRoute,GuidesHowToBecomeAnAngelInvestorIndiaRoute: GuidesHowToBecomeAnAngelInvestorIndiaRoute,GuidesHowToGrowOnInstagramIndiaRoute: GuidesHowToGrowOnInstagramIndiaRoute,GuidesHowToStartAPodcastIndiaRoute: GuidesHowToStartAPodcastIndiaRoute,GuidesHowToUseAiInBusinessIndiaRoute: GuidesHowToUseAiInBusinessIndiaRoute,PodcastSlugRoute: PodcastSlugRoute,PodcastIndexRoute: PodcastIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)